import { render, staticRenderFns } from "./imprintContent.vue?vue&type=template&id=467eee7e&scoped=true&"
import script from "./imprintContent.vue?vue&type=script&lang=js&"
export * from "./imprintContent.vue?vue&type=script&lang=js&"
import style0 from "./imprintContent.vue?vue&type=style&index=0&id=467eee7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467eee7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
